<template>
    <div>
        <div class="flex items-center gap-12" v-if="useHideInput && showInput">
            <simple-button
                icon="keyboard-arrow-left"
                look="icon"
                small
                @click="showInput = !showInput"
            />
            <simple-input
                :disabled="!editComponentId"
                :input-label="useInputLabel ? $t('components.component_id') : ''"
                no-spacing-before
                placeholder="component_id"
                v-model="inputValue"
            >
                <template #before>
                    <span class="text-secondary my-auto pl-12">#</span>
                </template>
                <template #after>
                    <div
                        class="my-auto p-8"
                        @click="editComponentId = !editComponentId"
                    >
                        <svg-icon class="w-18 h-18 text-primary-80" :type="!editComponentId ? 'edit' : 'check'"/>
                    </div>
                </template>
            </simple-input>
        </div>

        <div
            v-if="useHideInput && !showInput"
            class="flex items-center space-x-24"
        >
            <simple-button
                icon="keyboard-arrow-right"
                look="secondary"
                small
                @click="showInput = !showInput"
            >
                {{ $t('components.component_unique_id') }}
            </simple-button>

            <more-info-button
                use-auto-hide-label
                position="top"
            >
                <template #content>
                    <b class="block mb-4">{{ $t('general.more_info') }}</b>
                    <p v-html="$t('components.component_id_more_info')"></p>
                </template>
            </more-info-button>
        </div>
    </div>
</template>

<script>

import Input from '../forms/Input.vue';
import SvgIcon from './SvgIcon.vue';
import MoreInfoButton from './MoreInfoButton.vue';
import SimpleButton from "./SimpleButton.vue";

export default {
    components: {
        SimpleButton,
        MoreInfoButton,
        SvgIcon,
        'simple-input': Input,
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        useHideInput: {
            // Hide the input by default
            type: Boolean,
            default: true,
        },
        useInputLabel: {
            // Hide the label for the input by default
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            editComponentId: false,
            showInput: false,
        };
    },
    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
};
</script>